export default "__VITE_ASSET__DlUY5YB1__"